import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { hasPuppyCollegeAccess } from 'dpl/shared/buyer/utils';
import {
  BUYER_APPLICATIONS_PATH,
  BUYER_FAVORITES_PATH,
  BUYER_MESSAGES_PATH,
  BUYER_OWNER_HUB_PATH,
  BUYER_PAYMENTS_PATH,
  BUYER_SETTINGS_PATH,
  HOME_PATH,
  PUPPY_TRAINING_PROGRAM,
  PUPPY_TRAINING_PROGRAM_LANDING
} from 'dpl/shared/constants/urls';
import { FEATURES } from 'dpl/shared/constants/features';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';

import NavMenuOptions from './NavMenuOptions';

const IS_REL_OWNER_HUB_ENABLED = isFeatureEnabled(FEATURES.REL_OWNER_HUB);

export default function BuyerNavMenuOptions({ className }) {
  const { user, logout, isLoggedIn } = useCurrentUser();
  const { notifications } = useNotificationCounts();

  const { entitlements } = user || {};
  const { unreadMessagesCount } = notifications || {};

  const options = useMemo(
    () => [
      {
        iconName: 'fetch-message',
        label: 'Messages',
        url: BUYER_MESSAGES_PATH,
        ...(unreadMessagesCount && {
          badge: {
            text: unreadMessagesCount,
            color: 'rubber',
            variant: 'bright'
          }
        })
      },
      {
        iconName: 'fetch-application-alt',
        label: 'Applications',
        url: BUYER_APPLICATIONS_PATH
      },
      ...(IS_REL_OWNER_HUB_ENABLED && isLoggedIn
        ? [
            {
              iconName: 'fetch-dog',
              label: 'Your puppy',
              url: BUYER_OWNER_HUB_PATH
            }
          ]
        : []),
      {
        iconName: 'fetch-heart',
        label: 'Favorites',
        url: BUYER_FAVORITES_PATH
      },
      {
        iconName: 'fetch-payment',
        label: 'Payments',
        url: BUYER_PAYMENTS_PATH
      },
      {
        iconName: 'fetch-settings',
        label: 'Account Settings',
        url: BUYER_SETTINGS_PATH
      },
      {
        iconName: 'fetch-dog-square',
        label: 'Puppy Training',
        url: hasPuppyCollegeAccess(entitlements)
          ? PUPPY_TRAINING_PROGRAM
          : PUPPY_TRAINING_PROGRAM_LANDING
      },
      {
        iconName: 'fetch-logout-web',
        label: 'Log out',
        onClick: async () => {
          await logout();
          window.location = HOME_PATH;
        }
      }
    ],
    [entitlements, unreadMessagesCount, isLoggedIn]
  );

  return (
    <NavMenuOptions
      className={classnames('BuyerNavMenuOptions', className)}
      options={options}
    />
  );
}

BuyerNavMenuOptions.propTypes = {
  className: PropTypes.string
};

BuyerNavMenuOptions.defaultProps = {
  className: null
};
